import React from 'react';
import Header from '../components/homepage/Header';
import Hero from '../components/homepage/Hero';

function Homepage() {
    return (
        <div className="container">
            <Header />
            <Hero />
        </div>
    );
}

export default Homepage;
